import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberIdTypeForm from '../../../components/forms/MemberIdTypeForm';
import { useCreateMemberIdType } from '../../../hooks/useMemberIdTypeApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { MemberIdTypeDTO } from '../../../services/apiClient';

const MemberIdTypeCreate: React.FC = () => {
  const createMutation = useCreateMemberIdType();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Member Id Types', href: '/admin/memberidtypes' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: MemberIdTypeDTO) => {
    try {
      await createMutation.mutateAsync(data);
      navigate('/admin/memberidtypes');
    } catch (error) {
      console.error('Error creating MemberIdType:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/memberidtypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.MemberIdType.Edit"
    >
        <MemberIdTypeForm
          initialValues={{} as MemberIdTypeDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/memberidtypes')}
        />
    </AdminLayout>
  );
};

export default MemberIdTypeCreate;
